import React from "react";
import { useMutation } from "@apollo/client/react";
import { faPortrait, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useCurrentUser } from "@/components/user-context-provider/user-context-provider";
import { MUTATE_USER } from "@/gql/queries/mutations/mutate-user";
import { useModal } from "@/hooks/use-modal";

import ModalTitle from "./modal-title";

export default function ConfirmSetAvatarModal({
  animationUrl,
}: {
  animationUrl: string;
}) {
  const { closeModal } = useModal();
  const currentUser = useCurrentUser();
  const [mutateUser] = useMutation(MUTATE_USER);

  if (!currentUser) {
    closeModal();
    return null;
  }

  const onSetClicked = async () => {
    await mutateUser({
      variables: { avatarUrl: animationUrl },
    });
    closeModal();
  };

  const onCancelClicked = () => {
    closeModal();
  };

  return (
    <div>
      <ModalTitle>Set Profile Picture</ModalTitle>
      <Module>
        <p>Do you want to set this as your profile picture?</p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="right">
          <Button icon={faPortrait} onClick={onSetClicked} type="positive">
            Set profile picture
          </Button>
          <Button
            icon={faTimesCircle}
            onClick={onCancelClicked}
            type="negative"
          >
            Not now
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
}
